import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * EmptyState Component - Display when no data is available
 *
 * @example
 * <app-atom-empty-state
 *   message="No delivery partners available"
 *   icon="fa-file-o">
 * </app-atom-empty-state>
 */
@Component({
  selector: 'app-atom-empty-state',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss'],
})
export class EmptyStateComponent {
  // Signal-based inputs
  message = input<string>('No data available');
  submessage = input<string>('');
  icon = input<string>('fa-file-o');
  iconClass = input<string>('fa fa-file-o');
  containerClass = input<string>('');
  hasAction = input<boolean>(false);
}
